// extracted by mini-css-extract-plugin
export var button = "_n5-2";
export var card = "_n5-0";
export var closeButtonContainer = "_n5-3";
export var iconContainer = "_n5-1";